
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import AppSelectLedgerAccountVatField from "@/components/common/SelectLedgerAccountVatField.vue";
import {LedgerAccount, LedgerAccountBalans, LedgerAccountType, LedgerAccountVatField} from "@/models/ledger-account";
import {isStringNullOrWhitespace} from "@/utils/strings";
import {ISelectItem} from "winfakt-vue-components";
import { DossierConfigService, LedgerAccountService } from "@/services";
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";

export default FormLike.extend({
	data(){
		return {
			input: "",
			vatField: LedgerAccountVatField.NONE,
			groupCode: "",
			groupCodeFocused: false,
			balans: LedgerAccountBalans.ACTIVE,
			ledgerType: LedgerAccountType.NONE,
			allItems: [] as LedgerAccount[],
			DossierConfigService,
			tab: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>LedgerAccount,
			required: true
		}
	},
	computed: {
		balansItems():ISelectItem<LedgerAccountBalans>[] {
			return [
				{
					text: this.$ct("models.LedgerAccount.passive"),
					value: LedgerAccountBalans.PASSIVE
				},
				{
					text: this.$ct("models.LedgerAccount.active"),
					value: LedgerAccountBalans.ACTIVE
				},
				{
					text: this.$ct("models.LedgerAccount.opbrengsten"),
					value: LedgerAccountBalans.OPBRENGSTEN
				},
				{
					text: this.$ct("models.LedgerAccount.costs"),
					value: LedgerAccountBalans.COSTS
				}
			];
		},
		typeItems():ISelectItem<LedgerAccountType>[] {
			return [
				{
					text: this.$ct("models.LedgerAccount.types.none"),
					value: LedgerAccountType.NONE
				},
				{
					text: this.$ct("models.LedgerAccount.types.clients"),
					value: LedgerAccountType.CLIENT
				},
				{
					text: this.$ct("models.LedgerAccount.types.suppliers"),
					value: LedgerAccountType.SUPPLIER
				}
			];
		},
		groupCodeItems():LedgerAccount[] {
			return this.allItems.filter(i=> i.isGroup() && i.Code.startsWith(this.groupCode));
		},
		accountCodeIsParentGroupCode():boolean {
			if (this.input.endsWith(".....")){
				return true;
			}
			return false;
		},
		groupCodeValid():boolean {
			if (this.groupCode == this.input) {
				return true;
			}
			if (this.accountCodeIsParentGroupCode && this.groupCode == "") {
				return true;
			}
			if (isStringNullOrWhitespace(this.groupCode)) {
				return false;
			}
			if (!this.input.startsWith(this.groupCode.replaceAll(".", ""))) {
				return false;
			}
			let foundGroup = this.allItems.find(i=>i.Code == this.groupCode);
			if (!foundGroup) {
				return false;
			}
			return true;
		},
		extraFieldNames():ExtraFieldNamesConfig {
			return this.DossierConfigService.getExtraFieldNamesConfigs().LedgerAccountNames;
		},
		hasExtraFields():boolean{
			return this.extraFieldNames.hasActiveFields();
		},
		tabs():string[]{
			if (this.hasExtraFields){
				return [
					this.$ct("general").toString(),
					this.$ct("extra-fields").toString()
				];
			}
			return [];
		}
	},
	watch: {
		"value": {
			immediate: true,
			handler(){
				this.input = this.value.Description;
				this.vatField = this.value.VatField;
				this.groupCode = this.value.GroupCode;
				this.balans = this.value.Balans;
				this.ledgerType = this.value.Type;
			}
		},
		hasExtraFields(){
			if (!this.hasExtraFields) {
				this.tab = 0;
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			this.validate();
			if (!this.isValid) return;
			let item = new LedgerAccount(this.value.getJSON());
			item.Description = this.input;
			item.VatField = this.vatField;
			item.GroupCode = this.groupCode;
			item.Balans = this.balans;
			item.Type = this.ledgerType;
			await LedgerAccountService.update(item);
			this.$emit("saved");
			this.$emit("close");
		},
		onGroupBlur(){
			this.groupCode = this.groupCode.trim();
			if (this.groupCode == "") return;
		},
		onGroupClick(group:LedgerAccount){
			this.groupCode = group.Code;
		},
	},
	async mounted(){
		this.allItems = await LedgerAccountService.fetchLedgerAccounts();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
	components: {
		AppSelectLedgerAccountVatField,
		AppExtraFieldsEdit
	}
});
